import project from './project'
import homepage from './homepage'

const register = {
  path: 'register',
  component: resolve => require(['../../../components/pages/register'], resolve),
  redirect: 'register/homepage',
  children: [
    ...project,
    homepage
  ]
}

export default register



// WEBPACK FOOTER //
// ./src/router/pages/register/index.js